import * as Types from './contentfulTypes';

import gql from 'graphql-tag';
import * as ApolloReactCommon from 'react-apollo';
export const ImageFragmentDoc = gql`
    fragment Image on Asset {
  __typename
  width
  height
  url
  title
  description
  contentType
}
    `;
export const PromoTemplateCannedCollectionFragmentDoc = gql`
    fragment PromoTemplateCannedCollection on PromoTemplateCannedCollection {
  __typename
  sys {
    id
  }
  heading
  subheading
  size
  color
  backgroundColor
  stickToPrevious
  showAllEntries
  cardsCollection {
    items {
      sys {
        id
      }
      headline
      body
      target
      ctaText
      cardBackgroundImage {
        ...Image
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const PromoTemplateValuePropsFragmentDoc = gql`
    fragment PromoTemplateValueProps on PromoTemplateValueProps {
  __typename
  sys {
    id
  }
  headline
  description
  backgroundColor
  layout
  valuePropCardsCollection {
    items {
      sys {
        id
      }
      headline
      description
      icon {
        ...Image
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const PromoTemplatePartnerFragmentDoc = gql`
    fragment PromoTemplatePartner on PromoTemplatePartner {
  __typename
  sys {
    id
  }
  name
  logo {
    ...Image
  }
  description
  target
}
    ${ImageFragmentDoc}`;
export const PromoTemplatePartnerListFragmentDoc = gql`
    fragment PromoTemplatePartnerList on PromoTemplatePartnerList {
  __typename
  sys {
    id
  }
  title
  tagline
  description
  ctaText
  ctaTarget
  backgroundColor
  partnersCollection(limit: 10) {
    items {
      ...PromoTemplatePartner
    }
  }
  borders
}
    ${PromoTemplatePartnerFragmentDoc}`;
export const VideoFragmentDoc = gql`
    fragment Video on Asset {
  __typename
  sys {
    id
    spaceId
    environmentId
  }
  url
  title
  description
  contentType
}
    `;
export const PromoTemplateTestimonialFragmentDoc = gql`
    fragment PromoTemplateTestimonial on PromoTemplateTestimonial {
  __typename
  sys {
    id
  }
  author
  authorTitle
  authorOrganization {
    ...PromoTemplatePartner
  }
  associatedProduct
  image {
    ...Image
  }
  video {
    ...Video
  }
  testimonial
}
    ${PromoTemplatePartnerFragmentDoc}
${ImageFragmentDoc}
${VideoFragmentDoc}`;
export const PromoTemplateTestimonialCarouselFragmentDoc = gql`
    fragment PromoTemplateTestimonialCarousel on PromoTemplateTestimonialCarousel {
  __typename
  sys {
    id
  }
  headline
  displayStyle
  backgroundColor
  testimonialsCollection {
    items {
      ...PromoTemplateTestimonial
    }
  }
}
    ${PromoTemplateTestimonialFragmentDoc}`;
export const PromoTemplateInformationFragmentDoc = gql`
    fragment PromoTemplateInformation on PromoTemplateInformation {
  __typename
  sys {
    id
  }
  headline
  description
  image {
    ...Image
  }
  video {
    ...Video
  }
  ctaText
  ctaTarget
  ctaVariant
  secondaryCtaText
  secondaryCtaTarget
  secondaryCtaVariant
  layout
  backgroundColor
  backgroundImage {
    ...Image
  }
}
    ${ImageFragmentDoc}
${VideoFragmentDoc}`;
export const PromoTemplatePageContentSegmentOneFragmentDoc = gql`
    fragment PromoTemplatePageContentSegmentOne on PromoTemplatePageContent {
  slug
  title
  seoDescription
  seoTitle
  seoImage {
    ...Image
  }
  seoCanonical
  preventSearchEngine
  modulesCollection(limit: 24) {
    items {
      ...PromoTemplateCannedCollection
      ...PromoTemplateValueProps
      ...PromoTemplatePartnerList
      ...PromoTemplateTestimonialCarousel
      ...PromoTemplateInformation
    }
  }
  experimentName
  experimentValue
}
    ${ImageFragmentDoc}
${PromoTemplateCannedCollectionFragmentDoc}
${PromoTemplateValuePropsFragmentDoc}
${PromoTemplatePartnerListFragmentDoc}
${PromoTemplateTestimonialCarouselFragmentDoc}
${PromoTemplateInformationFragmentDoc}`;
export const PromoTemplateHeroFragmentDoc = gql`
    fragment PromoTemplateHero on PromoTemplateHero {
  __typename
  sys {
    id
  }
  eyebrow
  eyebrowBackground
  eyebrowImage {
    ...Image
  }
  headline
  description
  image {
    ...Image
  }
  video {
    ...Video
  }
  ctaText
  ctaTarget
  secondaryCtaText
  secondaryCtaTarget
  secondaryCtaVariant
  layout
  backgroundColor
  backgroundImage {
    ...Image
  }
  height
  showBottomBorder
}
    ${ImageFragmentDoc}
${VideoFragmentDoc}`;
export const PromoTemplateCollectionsFragmentDoc = gql`
    fragment PromoTemplateCollections on PromoTemplateCollections {
  __typename
  sys {
    id
  }
  backgroundColor
  backgroundImage {
    ...Image
  }
  layout
  showRoundedCorners
  headline
  description
  showAllEntries
  numOfEntriesPerCollection
  ctaText
  ctaTarget
  ctaVariant
  collectionSetsCollection {
    items {
      sys {
        id
      }
      context
      contextId
      filterName
      filterImage {
        ...Image
      }
      collectionModuleId
      presetCollectionId
    }
  }
}
    ${ImageFragmentDoc}`;
export const PromoTemplateArticlesCollectionFragmentDoc = gql`
    fragment PromoTemplateArticlesCollection on PromoTemplateArticlesCollection {
  __typename
  sys {
    id
  }
  heading
  description
  backgroundColor
  articleCollectionSetsCollection(limit: 24) {
    items {
      sys {
        id
      }
      filter
      articlesCollection(limit: 24) {
        items {
          sys {
            id
          }
          title
          description
          date
          slug
        }
      }
    }
  }
}
    `;
export const PromoTemplateFaqsFragmentDoc = gql`
    fragment PromoTemplateFaqs on PromoTemplateFaqs {
  __typename
  sys {
    id
  }
  headline
  faqsCollection {
    items {
      sys {
        id
      }
      question
      answer
    }
  }
  showHelpCenter
}
    `;
export const PromoTemplateCitationFragmentDoc = gql`
    fragment PromoTemplateCitation on PromoTemplateCitation {
  __typename
  sys {
    id
  }
  citations
  backgroundColor
}
    `;
export const PromoTemplatePromoBarFragmentDoc = gql`
    fragment PromoTemplatePromoBar on PromoTemplatePromoBar {
  __typename
  sys {
    id
  }
  headline
  description
  textLayout
  backgroundColor
  bannerColor
  centerContent
  primaryCtaText
  primaryCtaTarget
  hideBackgroundImages
}
    `;
export const PromoTemplatePageContentSegmentTwoFragmentDoc = gql`
    fragment PromoTemplatePageContentSegmentTwo on PromoTemplatePageContent {
  modulesCollection(limit: 24) {
    items {
      ...PromoTemplateHero
      ...PromoTemplateCollections
      ...PromoTemplateArticlesCollection
      ...PromoTemplateFaqs
      ...PromoTemplateCitation
      ...PromoTemplatePromoBar
    }
  }
}
    ${PromoTemplateHeroFragmentDoc}
${PromoTemplateCollectionsFragmentDoc}
${PromoTemplateArticlesCollectionFragmentDoc}
${PromoTemplateFaqsFragmentDoc}
${PromoTemplateCitationFragmentDoc}
${PromoTemplatePromoBarFragmentDoc}`;
export const EmbeddedPageContentDocument = gql`
    query EmbeddedPageContent($slug: String!, $domain: String!, $preview: Boolean, $locale: String!) {
  promoTemplateEmbeddedPageContentCollection(
    where: {slug: $slug, domain_contains_some: [$domain]}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      slug
      modulesCollection(limit: 16) {
        items {
          ...PromoTemplateCollections
        }
      }
    }
  }
}
    ${PromoTemplateCollectionsFragmentDoc}`;
export type EmbeddedPageContentQueryResult = ApolloReactCommon.QueryResult<Types.EmbeddedPageContentQuery, Types.EmbeddedPageContentQueryVariables>;
export const PageContentQueryDocument = gql`
    query PageContentQuery($slug: String!, $domain: String!, $preview: Boolean, $locale: String!) {
  promoTemplatePageContentCollection(
    where: {slug: $slug, domain_contains_some: [$domain]}
    limit: 3
    preview: $preview
    locale: $locale
  ) {
    items {
      slug
      title
      seoDescription
      seoTitle
      seoImage {
        ...Image
      }
      seoCanonical
      preventSearchEngine
      modulesCollection(limit: 24) {
        items {
          ...PromoTemplateCannedCollection
          ...PromoTemplateValueProps
          ...PromoTemplatePartnerList
          ...PromoTemplateTestimonialCarousel
          ...PromoTemplateInformation
          ...PromoTemplateHero
          ...PromoTemplateCollections
          ...PromoTemplateArticlesCollection
          ...PromoTemplateFaqs
          ...PromoTemplateCitation
          ...PromoTemplatePromoBar
        }
      }
      experimentName
      experimentValue
    }
  }
}
    ${ImageFragmentDoc}
${PromoTemplateCannedCollectionFragmentDoc}
${PromoTemplateValuePropsFragmentDoc}
${PromoTemplatePartnerListFragmentDoc}
${PromoTemplateTestimonialCarouselFragmentDoc}
${PromoTemplateInformationFragmentDoc}
${PromoTemplateHeroFragmentDoc}
${PromoTemplateCollectionsFragmentDoc}
${PromoTemplateArticlesCollectionFragmentDoc}
${PromoTemplateFaqsFragmentDoc}
${PromoTemplateCitationFragmentDoc}
${PromoTemplatePromoBarFragmentDoc}`;
export type PageContentQueryQueryResult = ApolloReactCommon.QueryResult<Types.PageContentQueryQuery, Types.PageContentQueryQueryVariables>;
export const PromoTemplatePageContentSegmentOneQueryDocument = gql`
    query PromoTemplatePageContentSegmentOneQuery($slug: String!, $domain: String!, $preview: Boolean, $locale: String!) {
  promoTemplatePageContentCollection(
    where: {slug: $slug, domain_contains_some: [$domain]}
    limit: 3
    preview: $preview
    locale: $locale
  ) {
    items {
      ...PromoTemplatePageContentSegmentOne
    }
  }
}
    ${PromoTemplatePageContentSegmentOneFragmentDoc}`;
export type PromoTemplatePageContentSegmentOneQueryQueryResult = ApolloReactCommon.QueryResult<Types.PromoTemplatePageContentSegmentOneQueryQuery, Types.PromoTemplatePageContentSegmentOneQueryQueryVariables>;
export const PromoTemplatePageContentSegmentTwoQueryDocument = gql`
    query PromoTemplatePageContentSegmentTwoQuery($slug: String!, $domain: String!, $preview: Boolean, $locale: String!) {
  promoTemplatePageContentCollection(
    where: {slug: $slug, domain_contains_some: [$domain]}
    limit: 3
    preview: $preview
    locale: $locale
  ) {
    items {
      ...PromoTemplatePageContentSegmentTwo
    }
  }
}
    ${PromoTemplatePageContentSegmentTwoFragmentDoc}`;
export type PromoTemplatePageContentSegmentTwoQueryQueryResult = ApolloReactCommon.QueryResult<Types.PromoTemplatePageContentSegmentTwoQueryQuery, Types.PromoTemplatePageContentSegmentTwoQueryQueryVariables>;